export * from './header.component';
export * from './header-main-data';



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/header/index.ts